import { render, staticRenderFns } from "./cms-link.vue?vue&type=template&id=42277656&scoped=true"
import script from "./cms-link.vue?vue&type=script&lang=js"
export * from "./cms-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42277656",
  null
  
)

export default component.exports